import { Link } from './link'
import { Typography } from '@tiptap/extension-typography'
import { Extensions } from '@tiptap/core'
import { Highlight } from '@tiptap/extension-highlight'
import { Code } from '@tiptap/extension-code'
import { Placeholder } from '@tiptap/extension-placeholder'
import { TaskList } from '@tiptap/extension-task-list'
import { TaskItem } from '@tiptap/extension-task-item'
import { HorizontalRule } from '@tiptap/extension-horizontal-rule'
import { Table } from '@tiptap/extension-table'
import { TableCell } from '@tiptap/extension-table-cell'
import { TableHeader } from '@tiptap/extension-table-header'
import { TableRow } from '@tiptap/extension-table-row'
import { Subscript } from '@tiptap/extension-subscript'
import { Superscript } from '@tiptap/extension-superscript'
import { Video } from './video'
import { BaseHubBlock } from './basehub-block'
import { BaseHubInlineBlock } from './basehub-inline-block'
import { UpdatedImage } from './captions'
import { CodeBlock } from './code-block'
import { Kbd } from './kbd'
import { OrderedList } from '@tiptap/extension-ordered-list'
import { ListItem } from '@tiptap/extension-list-item'
import { Italic } from '@tiptap/extension-italic'
import { Heading } from '@tiptap/extension-heading'
import { HardBreak } from '@tiptap/extension-hard-break'
import { Gapcursor } from '@tiptap/extension-gapcursor'
import { Dropcursor } from '@tiptap/extension-dropcursor'
import { Document } from '@tiptap/extension-document'
import { Strike } from '@tiptap/extension-strike'
import { Paragraph } from '@tiptap/extension-paragraph'
import { Text } from '@tiptap/extension-text'
import { Bold } from '@tiptap/extension-bold'
import { Blockquote } from '@tiptap/extension-blockquote'
import { BulletList } from '@tiptap/extension-bullet-list'
import { Underline } from '@tiptap/extension-underline'

export {
  Document,
  Text,
  // Nodes --------------
  Paragraph,
  Heading,
  Blockquote,
  HorizontalRule,
  // Lists --------------
  BulletList,
  OrderedList,
  ListItem,
  TaskList,
  TaskItem,
  // Marks --------------
  Strike,
  Bold,
  Italic,
  Code,
  Highlight,
  Typography,
  Link,
  Superscript,
  Subscript,
  Underline,
  // Utils --------------
  Dropcursor,
  Gapcursor,
  HardBreak,
  Placeholder,
  // Tables --------------
  Table,
  TableRow,
  TableHeader,
  TableCell,
}

export * from './basehub-block'
export * from './basehub-inline-block'
export * from './video'
export * from './captions'
export * from './code-block'
export * from './kbd'
export type { LinkAttributes, LinkOptions } from './link'

// for doing transformations/operations
export const richTextExtensionsForTransformations = [
  Document,
  Text,
  // Nodes --------------
  Paragraph,
  Heading,
  CodeBlock,
  Blockquote,
  HorizontalRule,
  BaseHubBlock,
  UpdatedImage,
  Video,
  // Lists --------------
  BulletList,
  OrderedList,
  ListItem,
  TaskList,
  TaskItem,
  // Marks --------------
  Strike,
  Kbd,
  Bold,
  Italic,
  Code.extend({
    excludes: null as any,
  }),
  Highlight.configure({ multicolor: true }),
  Typography,
  Link,
  BaseHubInlineBlock,
  Superscript,
  Subscript,
  Underline,
  // Utils --------------
  Dropcursor,
  Gapcursor,
  HardBreak,
  Placeholder.configure({
    placeholder: `Start writing here.
Press '/' to open the commands list.`,
  }),
  // Tables --------------
  Table,
  TableRow,
  TableHeader,
  TableCell,
] satisfies Extensions
